import AdminSkills from "../../../../components/Admin/admin-sections/AdminSkills";

const AdminSkillsPage = () => {
  return <AdminSkills />;
};

export default AdminSkillsPage;
